import { onBeforeUnmount, onMounted, readonly, ref, Ref } from "vue";

import { getCookieValue } from "@/services/cookies/cookies.service";

interface CookieWatcherOptions {
  pollIntervalMilliseconds?: number;
}

const DEFAULT_COOKIE_POLL_INTERVAL_MILLISECONDS = 1000;

export function useCookieWatcher(cookieName: string, options: CookieWatcherOptions = {}): Readonly<Ref<string | null>> {
  const cookieValue = ref<string | null>(getCookieValue(cookieName));
  let intervalId: number | undefined;

  function syncCookieValue(): void {
    const currentCookieValue = getCookieValue(cookieName);

    if (currentCookieValue === cookieValue.value) {
      return;
    }

    cookieValue.value = currentCookieValue;
  }

  onMounted(() => {
    intervalId = globalThis.window.setInterval(
      syncCookieValue,
      options.pollIntervalMilliseconds ?? DEFAULT_COOKIE_POLL_INTERVAL_MILLISECONDS
    );
    globalThis.document.addEventListener("visibilitychange", syncCookieValue);
    globalThis.window.addEventListener("focus", syncCookieValue);
  });

  onBeforeUnmount(() => {
    if (intervalId !== undefined) {
      globalThis.window.clearInterval(intervalId);
    }

    globalThis.document.removeEventListener("visibilitychange", syncCookieValue);
    globalThis.window.removeEventListener("focus", syncCookieValue);
  });

  return readonly(cookieValue);
}
